export default "/images/close.svg?dbc6d432e772ba7486f24fb3f57f2c7d";